import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { CacheService } from '@shared/services';
import { CompanyService } from '@shared/state/company/company.service';

@Directive({
	selector: '[accessControl]',
})
export class AccessControlDirective implements OnInit {
	@Input() feature: string;
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(
		private el: ElementRef,
		private auth: CompanyService,
		private readonly cache: CacheService
	) {}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - ngOnInit
	 **-------------------------------------------------------------------------------------
	 */
	async ngOnInit() {
		this.el.nativeElement.style.display = 'none';

		await this.checkAccess();
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - checkAccess
	 **-------------------------------------------------------------------------------------
	 */
	async checkAccess() {
		const companyId = await this.cache.get('secure:company_id');
		const feature: any = await this.auth.getFeature(companyId, this.feature);
		if (feature?.isActive) {
			this.el.nativeElement.style.display = 'block';
			return;
		} else {
			this.el.nativeElement.style.display = 'none';
		}
	}
}
